// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../css-loader/dist/cjs.js??ruleSet[1].rules[8].oneOf[6].use[1]!../../postcss-loader/dist/cjs.js??ruleSet[1].rules[8].oneOf[6].use[2]!../styles/colors.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Pagination_wrapper__mYZ9R {
    display: flex;
    padding-top: 10px;
    padding-bottom: 10px;
    align-items: center;
}

.Pagination_arrows__bKGHc {
    padding-top: 3px;
    display: flex;
}

.Pagination_arrows__bKGHc button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    margin-right: 12px;
    background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["lightui_surface_2"]};
}

.Pagination_arrows__bKGHc button:disabled {
    opacity: 0.6;
    cursor: default;
}

.Pagination_arrows__bKGHc button i {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["darkui_surface_1"]};
    line-height: 14px;
    font-size: 14px;
    font-weight: 300;
}

.Pagination_arrow-left__59\\+q8 {
    margin-right: 10px;
}

.Pagination_dropdown__8t-PJ {
    height: 32px;
    line-height: 32px;
    position: relative;
    background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["lightui_surface_2"]};
    padding: 8px 16px;
    border-radius: 4px;
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["darkui_surface_1"]};
    cursor: pointer;
    font-weight: 700;
    font-size: 14px;
    text-transform: capitalize;
}

.Pagination_dropdownElem__n0NBS {
    position: fixed;
    z-index: 1;
    min-width: 180px;
    margin-top: 16px;
    margin-left: -16px;
}

.Pagination_dropdownContainer__AMzsa {
    border: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["lightui_surface_4"]};
    border-radius: 3px;
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.2);
    background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["lightui_surface_1"]};
    padding: 8px;
}

.Pagination_dropdownItem__UDPqo {
    position: relative;
    padding: 10px 24px;
    border-radius: 4px;
    transition: background 0.3s;
    text-transform: capitalize;
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["darkui_surface_1"]};
    font-weight: 400;
    display: flex;
    align-items: center;
}

.Pagination_dropdownItem__UDPqo:hover {
    background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["lightui_surface_4"]};
}

.Pagination_dropdownItem__UDPqo svg {
    position: absolute;
    left: 3px;
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["blue_dark_1"]};
}

.Pagination_lowercase__fX17J {
    text-transform: lowercase;
}
`, "",{"version":3,"sources":["webpack://./node_modules/ui-connect/Pagination/Pagination.module.css"],"names":[],"mappings":"AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,8DAAmC;AACvC;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,mDAAuB;IACvB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,8DAAmC;IACnC,iBAAiB;IACjB,kBAAkB;IAClB,mDAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,8DAAmC;IACnC,kBAAkB;IAClB,0CAA0C;IAC1C,8DAAmC;IACnC,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,2BAA2B;IAC3B,0BAA0B;IAC1B,mDAAuB;IACvB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,8DAAmC;AACvC;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,mDAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":["@value (lightui_surface_2, darkui_surface_1, lightui_surface_1, black, lightui_surface_4, blue_dark_1) from '../styles/colors.module.css';\n\n.wrapper {\n    display: flex;\n    padding-top: 10px;\n    padding-bottom: 10px;\n    align-items: center;\n}\n\n.arrows {\n    padding-top: 3px;\n    display: flex;\n}\n\n.arrows button {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    margin-right: 12px;\n    background-color: lightui_surface_2;\n}\n\n.arrows button:disabled {\n    opacity: 0.6;\n    cursor: default;\n}\n\n.arrows button i {\n    color: darkui_surface_1;\n    line-height: 14px;\n    font-size: 14px;\n    font-weight: 300;\n}\n\n.arrow-left {\n    margin-right: 10px;\n}\n\n.dropdown {\n    height: 32px;\n    line-height: 32px;\n    position: relative;\n    background-color: lightui_surface_2;\n    padding: 8px 16px;\n    border-radius: 4px;\n    color: darkui_surface_1;\n    cursor: pointer;\n    font-weight: 700;\n    font-size: 14px;\n    text-transform: capitalize;\n}\n\n.dropdownElem {\n    position: fixed;\n    z-index: 1;\n    min-width: 180px;\n    margin-top: 16px;\n    margin-left: -16px;\n}\n\n.dropdownContainer {\n    border: 1px solid lightui_surface_4;\n    border-radius: 3px;\n    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.2);\n    background-color: lightui_surface_1;\n    padding: 8px;\n}\n\n.dropdownItem {\n    position: relative;\n    padding: 10px 24px;\n    border-radius: 4px;\n    transition: background 0.3s;\n    text-transform: capitalize;\n    color: darkui_surface_1;\n    font-weight: 400;\n    display: flex;\n    align-items: center;\n}\n\n.dropdownItem:hover {\n    background-color: lightui_surface_4;\n}\n\n.dropdownItem svg {\n    position: absolute;\n    left: 3px;\n    color: blue_dark_1;\n}\n\n.lowercase {\n    text-transform: lowercase;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"lightui_surface_2": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["lightui_surface_2"]}`,
	"darkui_surface_1": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["darkui_surface_1"]}`,
	"lightui_surface_1": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["lightui_surface_1"]}`,
	"black": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["black"]}`,
	"lightui_surface_4": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["lightui_surface_4"]}`,
	"blue_dark_1": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["blue_dark_1"]}`,
	"wrapper": `Pagination_wrapper__mYZ9R`,
	"arrows": `Pagination_arrows__bKGHc`,
	"arrow-left": `Pagination_arrow-left__59+q8`,
	"dropdown": `Pagination_dropdown__8t-PJ`,
	"dropdownElem": `Pagination_dropdownElem__n0NBS`,
	"dropdownContainer": `Pagination_dropdownContainer__AMzsa`,
	"dropdownItem": `Pagination_dropdownItem__UDPqo`,
	"lowercase": `Pagination_lowercase__fX17J`
};
export default ___CSS_LOADER_EXPORT___;
